import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import Swal from "sweetalert2";
import { Subject } from "rxjs";
import { PedidoIsencaoService } from "@core/services/pedido-isencao.service";
import { PedidoIsencaoInterface } from "app/module/pedido-isencao-interface";
import moment from "moment";

@Component({
	selector: 'app-listar-isencao',
	templateUrl: './listar-isencao.component.html',
	styleUrls: ['./listar-isencao.component.scss']
})
export class ListarIsencaoComponent implements OnInit {
	constructor(private pedidoIsencaoService: PedidoIsencaoService) {
		this._unsubscribeAll = new Subject();
	}

	private _unsubscribeAll: Subject<any>;
	private tempData = [];

	contentHeader: object;
	basicSelectedOption: number = 10;
	ColumnMode = ColumnMode;
	rows: Array<PedidoIsencaoInterface> | any = [];
	temp: Array<PedidoIsencaoInterface> | any = [];
	selectedStatus: any;
	dateOptions = {
		altInput: true,
		mode: 'single',
		altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
		defaultDate: moment(new Date).format('YYYY-MM-DD'),
		altFormat: "d/m/Y",
	};
	starting: boolean = false;

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;

	ngOnInit(): void {
		this.starting = true;
		this.contentHeader = {
			headerTitle: "Pedidos de Isenção",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Pedido",
						isLink: false,
					},
					{
						name: "Isenções",
						isLink: false,
					},
				],
			},
		};

		this.pedidoIsencaoService.get().subscribe(
			(res: any) => {
				if (res && res.data) {
					(this.rows = res.data), (this.temp = res.data), (this.tempData = this.rows);
				}
				this.starting = false;
			},
			(error) => {
				console.log(error);
				this.starting = false;
			}
		);
	}

	ngAfterContentChecked() {
		this.rows = [...this.rows];
	}

	idPedidoFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.id_pedido_isencao.toString().toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	clienteFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.cliente_nome?.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	statusFilter() {
		if (this.selectedStatus == 0) {
			this.rows = this.temp;
			return false
		}
		const val = this.selectedStatus

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.id_status.toString().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	produtoFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.produto_nome?.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	dtCompraFilter(event) {
		const val = event.target.value.toLowerCase();
		const [day, month, year] = val.split("/");
		const result = [year, month, day].join("-");
		if (val.length < 10) {
			this.rows = this.temp;
		}
		if (val.length == 10) {
			// filter our data
			const temp = this.temp.filter(function (d) {
				return d.dt_compra.toLowerCase().indexOf(result) !== -1 || !result;
			});
			// update the rows
			this.rows = temp;
			// Whenever the filter changes, always go back to the first page
			this.table.offset = 0;
		}
	}

	dtFimIsencaoFilter(event) {
		const val = event.target.value.toLowerCase();
		const [day, month, year] = val.split("/");
		const result = [year, month, day].join("-");
		if (val.length < 10) {
			this.rows = this.temp;
		}
		if (val.length == 10) {
			// filter our data
			const temp = this.temp.filter(function (d) {
				return d.dt_fim_isencao.toLowerCase().indexOf(result) !== -1 || !result;
			});
			// update the rows
			this.rows = temp;
			// Whenever the filter changes, always go back to the first page
			this.table.offset = 0;
		}
	}

	confirmDeleteAlert(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja excluir o pedido de isenção?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				this.pedidoIsencaoService.delete(data.id_pedido_isencao).subscribe(
					(res) => {
						Swal.fire({
							title: "Sucesso!",
							text: "O pedido de isenção foi excluído.",
							icon: "success",
							confirmButtonText: "Confirmar",
						}).then((result) => {
							if (result.isConfirmed) {
							this.pedidoIsencaoService.get().subscribe(
									(res: any) => {
										if (res && res.data) {
											this.rows = res.data;
											this.temp = res.data;
										}
									},
									(error) => error
								);
							}
						});
					},
					(error) => {
						Swal.fire("Erro!", "Ocorreu um erro ao excluir.", "error");
					}
				);
			}
		});
	}
}
